import * as API from '../api';

export const getFullRanking = (school) => {
    return API.getFullRanking(school ? `?school=${school}` : '');
};

export const getRankingById = (id) => {
    return API.getRankingById(id);
};



// WEBPACK FOOTER //
// ./src/controllers/ranking.js